module.exports = __webpack_public_path__ + "static/img/a-o-shearman.a0a1e7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/home-page-logos/a-o-shearman.png
// module id = m3Nl
// module chunks = 0